/* Nút tiến/lùi dùng chung cho các dải vuốt ngang.

   Cách dùng trong liquid:
     <div class="egr-rail" data-egr-rail>
       <button class="egr-rail__arrow egr-rail__arrow--prev">…</button>
       <div class="…" data-egr-rail-track>…các mục…</div>
       <button class="egr-rail__arrow egr-rail__arrow--next">…</button>
     </div>

   Nút chỉ bật khi ĐO ĐƯỢC là danh sách dài quá khung, không bật theo bề rộng
   màn hình: cùng một dải, số mục do người quản trị nhập trong theme editor nên
   lúc tràn lúc không. Máy tính (lưới 4 cột, không cuộn) thì nút ẩn hẳn để khỏi
   có hai nút chết nằm đó. */
(function () {
  'use strict';

  function setup(rail) {
    if (rail.dataset.egrRailReady === '1') return;
    var track = rail.querySelector('[data-egr-rail-track]');
    var prev = rail.querySelector('.egr-rail__arrow--prev');
    var next = rail.querySelector('.egr-rail__arrow--next');
    if (!track || !prev || !next) return;
    rail.dataset.egrRailReady = '1';

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    /* ĐỌC HẾT RỒI MỚI GHI, KHÔNG ĐƯỢC XEN KẼ.
       Bản cũ viết ĐỌC max -> GHI class -> ĐỌC scrollLeft: đổi class làm hỏng bố
       cục đã tính, nên lệnh đọc ngay sau đó ép trình duyệt dựng lại toàn bộ.
       Một lần thì không đáng kể, nhưng update() chạy cho MỖI dải mà trang chủ
       có ~12 dải, lại được ResizeObserver gọi dồn lúc đang tải. Lighthouse đo
       được 53+10+6ms "Buộc chỉnh lại luồng" dồn vào file này.
       Đọc trước ghi sau thì cả hàm chỉ còn tối đa một lần dựng lại. */
    function update() {
      var max = maxScroll();
      var viTri = track.scrollLeft;
      // 4px đệm: tránh bật/tắt nhấp nháy do làm tròn subpixel
      rail.classList.toggle('has-scroll', max > 4);
      prev.disabled = viTri <= 2;
      next.disabled = viTri >= max - 2;
    }

    // Nhảy gần trọn một khung, chừa lại một chút để khách bắt được mạch
    function step() {
      return Math.max(160, track.clientWidth * 0.8);
    }

    /* Mốc trái của từng mục, tính theo toạ độ cuộn của khung.
       Lưới 2 hàng thì hai mục cùng một cột trùng mốc -> lọc trùng. */
    function stops() {
      var base = track.getBoundingClientRect().left - track.scrollLeft;
      var list = [];
      Array.prototype.forEach.call(track.children, function (c) {
        var x = Math.round(c.getBoundingClientRect().left - base);
        if (list[list.length - 1] !== x) list.push(x);
      });
      return list;
    }

    /* Đi tới MỐC chứ không cộng thêm một đoạn px.
       Lý do: khung có scroll-snap, scrollBy({behavior:'smooth'}) bị snap huỷ
       giữa chừng nên bấm nút không nhúc nhích (đo được: scrollLeft đứng yên ở
       0). Nhảy thẳng vào mốc thì vừa chạy được vừa không bao giờ dừng lấp
       lửng giữa hai ô. */
    function go(dir) {
      var cur = track.scrollLeft;
      var max = maxScroll();
      var reach = dir > 0 ? cur + step() : cur - step();
      // tiến: các mốc trong (cur, reach] -> lấy mốc XA nhất
      // lùi:  các mốc trong [reach, cur) -> lấy mốc XA nhất về phía sau
      var fit = stops().filter(function (x) {
        return dir > 0 ? x > cur + 2 && x <= reach : x < cur - 2 && x >= reach;
      });
      var target = fit.length
        ? (dir > 0 ? fit[fit.length - 1] : fit[0])
        // Không mốc nào lọt tầm (mục rộng hơn cả khung) -> đi trọn một bước
        : reach;
      track.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    /* Dải nằm trong tab ẩn (Flash Sale) lúc gắn có bề ngang 0 -> đo ra "không
       tràn" và nút không bao giờ bật. Theo dõi kích thước để lúc tab được mở
       ra thì đo lại. */
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);

    update();
    // Font Be Vietnam Pro nạp sau có thể đổi bề rộng chữ -> đo lại
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
  }

  function init() {
    document.querySelectorAll('[data-egr-rail]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor dựng lại section thì gắn lại
  document.addEventListener('shopify:section:load', init);
})();
